'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactTransitionGroup = require('react-transition-group');

require('../components/containers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// make ValueContainer a transition group
var AnimatedValueContainer = function AnimatedValueContainer(WrappedComponent) {
  return function (props) {
    return _react2.default.createElement(_reactTransitionGroup.TransitionGroup, _extends({ component: WrappedComponent }, props));
  };
};

exports.default = AnimatedValueContainer;


//////////////////
// WEBPACK FOOTER
// ./~/react-select/lib/animated/ValueContainer.js
// module id = 1018
// module chunks = 170434399708630